// extracted by mini-css-extract-plugin
export default {"documentList":"CondoInfoSection_documentList__yVLfn"};